module.exports = __webpack_public_path__ + "static/media/header-appGallery.cead03e6.svg";